import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createElementBlock as _createElementBlock, Fragment as _Fragment, unref as _unref, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-916a1356"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "editor"
}
const _hoisted_2 = {
  key: 1,
  class: "temporary-actions"
}
const _hoisted_3 = {
  key: 3,
  class: "temporary-actions"
}
const _hoisted_4 = {
  key: 5,
  class: "temporary-actions"
}
const _hoisted_5 = { class: "field diff-content" }

import { Editor, EditorContent } from "@tiptap/vue-3";
import {
  onBeforeUnmount,
  onMounted,
  ref,
  watch,
  computed,
} from "vue";
import sanitizeHtml from "sanitize-html";
import { RichTextExtension, type RichTextExtensionOptions } from "./rich-text";
import TooltipIcon from "../tooltips/TooltipIcon.vue";
import { emptyRichText } from "@/plugins/html";
import diff from "html-diff-ts";


export default /*#__PURE__*/_defineComponent({
  __name: 'RichText',
  props: /*#__PURE__*/_mergeModels({
    label: {},
    diffValue: {},
    options: { default: () => {
      return {
        table: {
          resizable: true,
        },
      } as Partial<RichTextExtensionOptions>;
    } },
    required: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const editor = ref<Editor>();

const model = _useModel<string>(__props, "modelValue");

const props = __props;

const empty = computed(() => {
  return emptyRichText(model.value);
});

watch(
  () => [model.value, props.diffValue],
  () => {
    const html = sanitizeHtml(model.value);
    if (props.options.diff) {
      const diffHtml = sanitizeHtml(props.diffValue ?? "");
      const diffResult = diff(diffHtml, html);
      editor.value.commands.setContent(diffResult, false);
    } else if (sanitizeHtml(editor.value.getHTML()) !== html) {
      editor.value.commands.setContent(html, false);
    }
  },
);

onMounted(() => {
  let html = sanitizeHtml(model.value);
  if (props.options.diff) {
    const diffHtml = sanitizeHtml(props.diffValue ?? "");
    html = diff(diffHtml, html);
  }
  editor.value = new Editor({
    content: html,
    editable: !props.readonly,
    extensions: [RichTextExtension.configure(props.options)],
    onUpdate: () => {
      model.value = sanitizeHtml(editor.value.getHTML());
    },
  });
});

onBeforeUnmount(() => {
  editor.value.destroy();
});

return (_ctx: any,_cache: any) => {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!

  return (editor.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_toolbar, {
          class: "toolbar",
          density: "compact"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_toolbar_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
                (_ctx.required && empty.value)
                  ? (_openBlock(), _createBlock(TooltipIcon, {
                      key: 0,
                      class: "ml-1",
                      text: "Field is required."
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (!_ctx.readonly)
              ? (_openBlock(), _createBlock(_component_v_spacer, { key: 0 }))
              : _createCommentVNode("", true),
            (!_ctx.readonly)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_v_tooltip, {
                    text: "Bold (Ctrl-B)",
                    location: "bottom"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn, _mergeProps(props, {
                        icon: "mdi-format-bold",
                        density: "compact",
                        class: "action",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (editor.value.chain().focus().toggleBold().run())),
                        active: editor.value.isActive('bold')
                      }), null, 16, ["active"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_tooltip, {
                    text: "Italic (Ctrl-I)",
                    location: "bottom"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn, _mergeProps(props, {
                        icon: "mdi-format-italic",
                        density: "compact",
                        class: "action",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (editor.value.chain().focus().toggleItalic().run())),
                        active: editor.value.isActive('italic')
                      }), null, 16, ["active"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_tooltip, {
                    text: "Header 4",
                    location: "bottom"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn, _mergeProps(props, {
                        icon: "mdi-format-header-4",
                        density: "compact",
                        class: "action",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (editor.value.chain().focus().toggleHeading({ level: 4 }).run())),
                        active: editor.value.isActive('heading', { level: 4 })
                      }), null, 16, ["active"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_tooltip, {
                    text: "Header 5",
                    location: "bottom"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn, _mergeProps(props, {
                        icon: "mdi-format-header-5",
                        density: "compact",
                        class: "action",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (editor.value.chain().focus().toggleHeading({ level: 5 }).run())),
                        active: editor.value.isActive('heading', { level: 5 })
                      }), null, 16, ["active"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_tooltip, {
                    text: "Header 6",
                    location: "bottom"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn, _mergeProps(props, {
                        icon: "mdi-format-header-6",
                        density: "compact",
                        class: "action",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (editor.value.chain().focus().toggleHeading({ level: 6 }).run())),
                        active: editor.value.isActive('heading', { level: 6 })
                      }), null, 16, ["active"])
                    ]),
                    _: 1
                  }),
                  (!editor.value.isActive('bulletList'))
                    ? (_openBlock(), _createBlock(_component_v_tooltip, {
                        key: 0,
                        text: "Toggle Bullet List",
                        location: "bottom"
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_btn, _mergeProps(props, {
                            icon: "mdi-format-list-bulleted",
                            class: "action",
                            density: "compact",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (editor.value.chain().focus().toggleBulletList().run()))
                          }), null, 16)
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createElementBlock("span", _hoisted_2, [
                        _createVNode(_component_v_tooltip, {
                          text: "Sink List Item",
                          location: "bottom"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_btn, _mergeProps(props, {
                              icon: "mdi-format-indent-increase",
                              class: "action",
                              density: "compact",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (editor.value.chain().focus().sinkListItem('listItem').run()))
                            }), null, 16)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_tooltip, {
                          text: "Lift List Item",
                          location: "bottom"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_btn, _mergeProps(props, {
                              icon: "mdi-format-indent-decrease",
                              class: "action",
                              density: "compact",
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (editor.value.chain().focus().liftListItem('listItem').run()))
                            }), null, 16)
                          ]),
                          _: 1
                        })
                      ])),
                  (!editor.value.isActive('orderedList'))
                    ? (_openBlock(), _createBlock(_component_v_tooltip, {
                        key: 2,
                        text: "Toggle Ordered List",
                        location: "bottom"
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_btn, _mergeProps(props, {
                            icon: "mdi-format-list-numbered",
                            class: "action",
                            density: "compact",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (editor.value.chain().focus().toggleOrderedList().run()))
                          }), null, 16)
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createElementBlock("span", _hoisted_3, [
                        _createVNode(_component_v_tooltip, {
                          text: "Sink List Item",
                          location: "bottom"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_btn, _mergeProps(props, {
                              icon: "mdi-format-indent-increase",
                              class: "action",
                              density: "compact",
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (editor.value.chain().focus().sinkListItem('listItem').run()))
                            }), null, 16)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_tooltip, {
                          text: "Lift List Item",
                          location: "bottom"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_btn, _mergeProps(props, {
                              icon: "mdi-format-indent-decrease",
                              class: "action",
                              density: "compact",
                              onClick: _cache[10] || (_cache[10] = ($event: any) => (editor.value.chain().focus().liftListItem('listItem').run()))
                            }), null, 16)
                          ]),
                          _: 1
                        })
                      ])),
                  (!editor.value.isActive('table'))
                    ? (_openBlock(), _createBlock(_component_v_tooltip, {
                        key: 4,
                        text: "Insert Table",
                        location: "bottom"
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_btn, _mergeProps(props, {
                            icon: "mdi-table",
                            density: "compact",
                            class: "action",
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (
                editor.value
                  .chain()
                  .focus()
                  .insertTable({ rows: 3, cols: 3, withHeaderRow: true })
                  .run()
              ))
                          }), null, 16)
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createElementBlock("span", _hoisted_4, [
                        _createVNode(_component_v_tooltip, {
                          text: "Insert Column Before",
                          location: "bottom"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_btn, _mergeProps(props, {
                              icon: "mdi-table-column-plus-before",
                              density: "compact",
                              class: "action",
                              onClick: _cache[12] || (_cache[12] = ($event: any) => (editor.value.chain().focus().addColumnBefore().run()))
                            }), null, 16)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_tooltip, {
                          text: "Insert Column After",
                          location: "bottom"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_btn, _mergeProps(props, {
                              icon: "mdi-table-column-plus-after",
                              density: "compact",
                              class: "action",
                              onClick: _cache[13] || (_cache[13] = ($event: any) => (editor.value.chain().focus().addColumnAfter().run()))
                            }), null, 16)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_tooltip, {
                          text: "Remove Column",
                          location: "bottom"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_btn, _mergeProps(props, {
                              icon: "mdi-table-column-remove",
                              density: "compact",
                              class: "action",
                              onClick: _cache[14] || (_cache[14] = ($event: any) => (editor.value.chain().focus().deleteColumn().run()))
                            }), null, 16)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_tooltip, {
                          text: "Insert Row Before",
                          location: "bottom"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_btn, _mergeProps(props, {
                              icon: "mdi-table-row-plus-before",
                              density: "compact",
                              class: "action",
                              onClick: _cache[15] || (_cache[15] = ($event: any) => (editor.value.chain().focus().addRowBefore().run()))
                            }), null, 16)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_tooltip, {
                          text: "Insert Row After",
                          location: "bottom"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_btn, _mergeProps(props, {
                              icon: "mdi-table-row-plus-after",
                              density: "compact",
                              class: "action",
                              onClick: _cache[16] || (_cache[16] = ($event: any) => (editor.value.chain().focus().addRowAfter().run()))
                            }), null, 16)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_tooltip, {
                          text: "Remove Row",
                          location: "bottom"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_btn, _mergeProps(props, {
                              icon: "mdi-table-row-remove",
                              density: "compact",
                              class: "action",
                              onClick: _cache[17] || (_cache[17] = ($event: any) => (editor.value.chain().focus().deleteRow().run()))
                            }), null, 16)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_tooltip, {
                          text: "Merge Cells",
                          location: "bottom"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_btn, _mergeProps(props, {
                              icon: "mdi-table-merge-cells",
                              density: "compact",
                              class: "action",
                              onClick: _cache[18] || (_cache[18] = ($event: any) => (editor.value.chain().focus().mergeCells().run()))
                            }), null, 16)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_tooltip, {
                          text: "Split Cell",
                          location: "bottom"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_btn, _mergeProps(props, {
                              icon: "mdi-table-split-cell",
                              density: "compact",
                              class: "action",
                              onClick: _cache[19] || (_cache[19] = ($event: any) => (editor.value.chain().focus().splitCell().run()))
                            }), null, 16)
                          ]),
                          _: 1
                        })
                      ]))
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(EditorContent), {
            editor: editor.value,
            modelValue: model.value,
            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((model).value = $event))
          }, null, 8, ["editor", "modelValue"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})